module.exports = __webpack_public_path__ + "static/img/head-1.87589b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/priceCard/head-1.png
// module id = MbtX
// module chunks = 1